import { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../context/userContext';
import { ROLE, UserType, PatientSubRole } from '../interface/interface';
import { useSubNavItems } from '../hooks/useSubNavItems';
import SubNavBar from './SubNavBar';
import NavItem from './NavItem';

const MobileNavBar = ({
  nav,
  cartLineItemsExists,
}: {
  nav: Array<UserType>;
  cartLineItemsExists?: number;
}) => {
  const [isPatient, setIsPatient] = useState<boolean>(false);
  const [patientRole, setPatientRole] = useState<PatientSubRole>();
  const [mobileDropdownLink, setMobileDropdownLink] = useState<UserType[]>([]);

  const {
    userDetail,
    activeItem,
    setActiveItem,
    setIsMobileDropdownOpen,
    isMobileDropdownOpen,
  } = useContext(UserContext);

  const mobileMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target as Node)
      ) {
        setIsMobileDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (userDetail) {
      setIsPatient(userDetail.role === ROLE.Patients);
      setPatientRole(
        userDetail.internal
          ? PatientSubRole.InternalPatient
          : PatientSubRole.ExternalPatient,
      );
    }
  }, [userDetail]);

  const subNavItems = useSubNavItems(mobileDropdownLink, patientRole);

  const handleToggleDropdown = (item: UserType) => {
    setActiveItem(item.name);
    setIsMobileDropdownOpen(false);
    localStorage.removeItem('selectedBrand');
    localStorage.removeItem('selectedForm');
    localStorage.removeItem('selectedArea');

    if (!item.subNav || !isPatient) return;

    if (isMobileDropdownOpen) {
      setIsMobileDropdownOpen(false);
    } else {
      setMobileDropdownLink(item.subNav);
      setIsMobileDropdownOpen(true);
    }
  };

  return (
    <div ref={mobileMenuRef}>
      <SubNavBar
        items={subNavItems}
        isVisible={isPatient && isMobileDropdownOpen}
        isMobile={true}
      />

      <div
        className={`flex lg:hidden fixed bottom-0 py-3 px-9 
        bg-secondary-cornflowerblue-100 w-full items-center justify-between z-50`}
      >
        {nav
          .filter((x) => !x.mobileOnlyHide)
          .map((element) => (
            <NavItem
              key={element.name}
              element={element}
              cartCount={cartLineItemsExists}
              onClick={() => handleToggleDropdown(element)}
              isDropdownOpen={isMobileDropdownOpen}
              isActive={activeItem === element.name}
            />
          ))}
      </div>
    </div>
  );
};

export default MobileNavBar;
